<div class="container">
  <br /><br />
  <p style="font-weight: bolder; font-size: 30px">Enter Otp</p>
  <p style="font-size: 12px">
    We sent an OTP to your device, Please enter the OTP below to confirm
    transaction
  </p>
  <div>
    <input class="form-control" id="cardPan" type="text" placeholder="****" />
  </div>

  <p>Didn't get code? <span class="text-primary ml-2">Resend Code</span></p>
</div>
